<template>
  <div class="breakdown-card">
    <div class="w-full p-4 flex items-center">
      <BaseText type="label" size="sm" class="text-text-normal">
        Platform Breakdown
      </BaseText>
    </div>
    <div class="w-full flex items-center justify-between px-4 pb-6">
      <GraphMetricSelector
        :selected-metric="selectedMetrics.left"
        side="left"
        color="#8E70F2"
        :disable-selector="isDataPublic"
        @changeMetric="handleMetricChange('left', $event)"
      />
      <GraphMetricSelector
        :selected-metric="selectedMetrics.right"
        side="right"
        color="#FFAA51"
        :disable-selector="isDataPublic"
        @changeMetric="handleMetricChange('right', $event)"
      />
    </div>
    <div class="relative w-full pb-3">
      <transition>
        <div v-if="loading" class="absolute w-full h-full flex items-center justify-center z-50">
          <BaseLoadingSpinnerCircle class="mb-10 text-icon-normal" :width="24" :height="24" :duration="1" />
        </div>
      </transition>
      <MultiMetricBreakdownBarGraph
        class="transition-opacity" :class="{ 'opacity-50': loading }"
        :selected-metrics="selectedMetrics ? [selectedMetrics.left, selectedMetrics.right] : []"
        :data-groups="dataGroups"
        :currency-region="currencyRegion"
        :bar-colors="['#8E70F2', '#FFAA51']"
        :graph-x-padding="12"
        :bar-spacing="44"
      />
    </div>
    <div class="w-full p-4 border-t border-border-normal">
      <BaseText type="label" size="sm" class="text-text-normal">
        Placement Breakdown
      </BaseText>
    </div>
    <div class="relative w-full pb-3">
      <transition>
        <div v-if="loading" class="absolute w-full h-full flex items-center justify-center z-50">
          <BaseLoadingSpinnerCircle class="mb-10 text-icon-normal" :width="24" :height="24" :duration="1" />
        </div>
      </transition>
      <HorizontalMetricBarGraph
        class="transition-opacity" :class="{ 'opacity-50': loading }"
        :selected-metrics="selectedMetrics ? [selectedMetrics.left, selectedMetrics.right] : []"
        :data-groups="placementGroups"
        :currency-region="currencyRegion"
        :bar-colors="['#8E70F2', '#FFAA51']"
      />
    </div>
  </div>
</template>

<script>
import GraphMetricSelector from './graphs/GraphMetricSelector.vue'
import MultiMetricBreakdownBarGraph from './graphs/MultiMetricBreakdownBarGraph.vue'
import HorizontalMetricBarGraph from './graphs/HorizontalMetricBarGraph.vue'

export default {
  name: 'PlatformBreakdown',
  components: {
    GraphMetricSelector,
    MultiMetricBreakdownBarGraph,
    HorizontalMetricBarGraph
  },
  props: {
    selectedMetrics: {
      type: Object,
      required: true
    },
    dataGroups: {
      type: Array,
      required: true
    },
    placementGroups: {
      type: Array,
      required: true
    },
    currencyRegion: {
      type: String,
      default: 'USD'
    },
    loading: {
      type: Boolean,
      default: false
    },
    isDataPublic: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleMetricChange (side, metricKey) {
      this.$emit('changeMetric', {
        ...this.selectedMetrics,
        [side]: metricKey
      })
    }
  }
}
</script>

<style scoped>
.v-enter-active, .v-leave-active {
  transition: opacity 150ms ease-in-out;
}
.v-enter-from, .v-enter, .v-leave-to {
  opacity: 0;
}
.v-enter-to, .v-leave-from {
  opacity: 1;
}
</style>